import { Fragment, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  setProcessing,
  setFormValue,
  toggleRawDataField,
  loadRawData,
  RAW_DATA_PAGE_SIZE,
} from "../../redux/slices/notificationspageslice";
import { addNotification } from "../../redux/slices/notificationsslice";
import { apiErrorsHandler, getErrorMessages } from "../../api/httpclient";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Toolbar,
  ToolbarItem,
  ToolbarSeparator,
  ToolbarSpacer,
  Button,
  DropDownButton,
} from "@progress/kendo-react-buttons";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { AlertNotificationNotGrouped } from "./alertnotificationnotgrouped";
import { AlertNotificationGrouped } from "./alertnotificationgrouped";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { DropDownListById } from "../../forms/form-components";
import {
  Grid,
  GridColumn,
  GridColumnMenuFilter,
} from "@progress/kendo-react-grid";
import { filterBy } from "@progress/kendo-data-query";
import { orderBy } from "@progress/kendo-data-query";
import { List } from "../../components/list";
import {
  formatDateTime,
  formatNumberWithCommas,
  getAlertImportances,
  getAlertRecurrsEveryIntervals,
  getAlertCoveredPeriodIntervals,
  getAlertVariantCoveredPeriodIntervals,
  getDataTypeIcon,
  getExpressionIcon,
  notificationDurationMiddle,
} from "../../lib/utils";
import parse from "html-react-parser";
import * as htmlToImage from "html-to-image";
import download from "downloadjs";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

const rawDataListItemRenderer = (currentTheme) => (props, item, index) => {
  const dataTypeIcon = getDataTypeIcon(item.DataTypeId);
  const expressionIcon = getExpressionIcon(item.IsAggregate);
  const onFieldCheck = props.onFieldCheck;

  return (
    <div key={item.Id} className={`list-item`}>
      <div style={{ width: 28 }}>
        <Checkbox value={item.Checked} onChange={(e) => onFieldCheck(item)} />
      </div>
      <div className={`list-item-data-type-icon k-icon ${dataTypeIcon} `}></div>
      <div
        className={`list-item-expression-icon k-icon ${expressionIcon}`}
      ></div>
      <div className="list-item-title">{item.Title}</div>
    </div>
  );
};

export const AlertNotification = (props) => {
  const {
    currentTheme,
    pageState,
    onMarkAsRead,
    onMarkAsUnread,
    onRemove,
    onClose,
    ...other
  } = props;

  const formValues = pageState.formValues;
  const item = pageState.formValues;

  const { t } = useTranslation();

  const markText = item.Status == -1 ? t("notifications.read") : t("notifications.unread");
  const markIcon = item.Status == -1 ? t("notifications.outline") : t("notifications.circle");
  const importanceText = getAlertImportances().find(
    (e) => e.Id == item.Importance
  )?.Title;
  const recurrsEveryText = getAlertRecurrsEveryIntervals().find(
    (e) => e.Id == item.RecurrsEvery
  )?.Title;
  const coveredPeriodText = getAlertCoveredPeriodIntervals().find(
    (e) => e.Id == item.CoveredPeriod
  )?.Title;
  const variantCoveredPeriodText = item.IsVariant
    ? getAlertVariantCoveredPeriodIntervals().find(
        (e) => e.Id == item.VariantCoveredPeriod
      )?.Title
    : "No";

  //console.log("..", item.Importance, importanceText)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //raw data
  const [isTopVisible, setIsTopVisible] = useState(true);

  const handleToggleTop = (e) => {
    setIsTopVisible(!isTopVisible);
  };

  const rawDataGridGroupedRef = useRef(null);
  const rawDataGridNotGroupedRef = useRef(null);

  const rawDataGridExportToExcelGroupedRef = useRef(null);
  const rawDataGridExportToExcelNotGroupedRef = useRef(null);

  const handleShowGenerate = (e) => {
    dispatch(setFormValue({ id: "rawDataDialogOpen", value: true }));
    dispatch(
      setFormValue({
        id: "rawDataFields",
        value: formValues.rawDataFields.map((e) => ({ ...e, IsVisible: true })),
      })
    );
  };

  const handleLoadRawData = (e) => {
    dispatch(loadRawData(t)).then(
      (response) => {},
      (err) => {
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          if (!errorMessages || errorMessages.length == 0)
            errorMessages = [t("notifications.unknown_error")];
          else {
            errorMessages = getErrorMessages(errorMessages, 1);
          }

          dispatch(
            addNotification({
              text: errorMessages[0],
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          let errorMessage = t("notifications.unknown_error");
          dispatch(
            addNotification({
              text: errorMessage,
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        apiErrorsHandler({}, dispatch, navigate, err, null, {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      }
    );
  };

  const handleRawDataExportToExcel = (e) => {};

  const handleRawDataGridPageChange = (e) => {
    const rawDataGridFilter = formValues.rawDataGridFilter;
    const rawDataGridSort = formValues.rawDataGridSort;
    const skip = e.page.skip;

    const data =
      rawDataGridFilter &&
      rawDataGridFilter.filters &&
      rawDataGridFilter.filters.length > 0
        ? orderBy(
            filterBy(formValues.rawDataValues, rawDataGridFilter),
            rawDataGridSort
          )
        : orderBy(formValues.rawDataValues, rawDataGridSort);

    dispatch(
      setFormValue({
        id: "rawDataGridPageSkip",
        value: skip,
      })
    );

    dispatch(
      setFormValue({
        id: "rawDataGridData",
        value: data,
      })
    );

    dispatch(
      setFormValue({
        id: "rawDataGridDataPaged",
        value: data.slice(skip, skip + RAW_DATA_PAGE_SIZE),
      })
    );
  };

  const handleRawDataGridFilter = (e) => {
    const rawDataGridSort = formValues.rawDataGridSort;
    const rawDataGridPageSkip = formValues.rawDataGridPageSkip;
    const filter = e.filter;

    //get the filtered and ordered data
    const data =
      filter && filter.filters && filter.filters.length > 0
        ? orderBy(filterBy(formValues.rawDataValues, filter), rawDataGridSort)
        : orderBy(formValues.rawDataValues, rawDataGridSort);

    dispatch(
      setFormValue({
        id: "rawDataGridPageSkip",
        value: 0,
      })
    );

    dispatch(
      setFormValue({
        id: "rawDataGridFilter",
        value: filter,
      })
    );

    dispatch(
      setFormValue({
        id: "rawDataGridData",
        value: data,
      })
    );

    dispatch(
      setFormValue({
        id: "rawDataGridDataPaged",
        value: data.slice(0, RAW_DATA_PAGE_SIZE),
      })
    );
  };

  const handleRawDataGridSortChange = (e) => {
    const rawDataGridFilter = formValues.rawDataGridFilter;
    const rawDataGridPageSkip = formValues.rawDataGridPageSkip;
    const sort = e.sort;

    //get the filtered and ordered data
    const data =
      rawDataGridFilter &&
      rawDataGridFilter.filters &&
      rawDataGridFilter.filters.length > 0
        ? orderBy(filterBy(formValues.rawDataValues, rawDataGridFilter), sort)
        : orderBy(formValues.rawDataValues, sort);

    dispatch(
      setFormValue({
        id: "rawDataGridSort",
        value: sort,
      })
    );

    dispatch(
      setFormValue({
        id: "rawDataGridData",
        value: data,
      })
    );

    dispatch(
      setFormValue({
        id: "rawDataGridDataPaged",
        value: data.slice(
          rawDataGridPageSkip,
          rawDataGridPageSkip + RAW_DATA_PAGE_SIZE
        ),
      })
    );
  };

  const handleRawDataGridExportToExcel = (e) => {
    if (item.IsGrouped && rawDataGridExportToExcelGroupedRef != null)
      rawDataGridExportToExcelGroupedRef.current.save();
    else if (!item.IsGrouped && rawDataGridExportToExcelNotGroupedRef != null)
      rawDataGridExportToExcelNotGroupedRef.current.save();
  };
  //raw data

  let notifyThroughText = "";

  if (!item.NotifyThroughApplication && !item.NotifyThroughEmail)
    notifyThroughText = t("notifications.none");
  else if (item.NotifyThroughApplication && item.NotifyThroughEmail)
    notifyThroughText = t("notifications.appemail");
  else if (item.NotifyThroughApplication)
    notifyThroughText = t("notifications.app");
  else if (item.NotifyThroughEmail) notifyThroughText = t("notifications.email");

  const toolsVisibleIcon = pageState.toolsVisible ? "unpin" : "pin";
  const toolsVisibleTitle = pageState.toolsVisible
    ? t("notifications.unpin")
    : t("notifications.unpin");

  //snapshot
  const contentZoneRef = useRef(null);

  const getSnapshot = async (e) => {
    let w = parseInt(contentZoneRef.current.innerWidth);
    let h = parseInt(contentZoneRef.current.innerHeight); //parseInt(w * 0.75);

    let dataUrl = null;

    try {
      dataUrl = await htmlToImage.toJpeg(contentZoneRef.current, {
        width: w,
        height: h,
        quality: 0.9, //skipAutoScale: true,
        //backgroundColor: "#002240"
      });

      return dataUrl;
    } catch (ex) {
      return null;
    }
  };

  const handleOnSnapshot = async (e) => {
    let dataUrl = await getSnapshot();
    if (dataUrl) download(dataUrl, "vas-alerts.jpg");
  };

  return (
    <Fragment>
      <div className="alert-notification">
        <div className="toolbar">
          <Toolbar>
            {!props.isMobile && (
              <Fragment>
                <ToolbarItem>
                  <Button
                    disabled={pageState.processing}
                    style={{ color: currentTheme.primary }}
                    icon={toolsVisibleIcon}
                    onClick={props.onToolsToggle}
                  >
                    {toolsVisibleTitle}
                  </Button>
                </ToolbarItem>
                <ToolbarSeparator />
                <ToolbarItem>
                  <Button
                    disabled={pageState.processing}
                    style={{ color: currentTheme.primary }}
                    icon={markIcon}
                    onClick={(e) => {
                      if (item.Status == -1)
                        props.onMarkAsRead(pageState.formValues.Id);
                      else props.onMarkAsUnread(pageState.formValues.Id);
                    }}
                  >
                    {markText}
                  </Button>
                </ToolbarItem>

                <ToolbarSeparator />

                <ToolbarItem>
                  <Button
                    disabled={pageState.processing}
                    style={{ color: currentTheme.primary }}
                    icon={"delete"}
                    onClick={(e) => onRemove(pageState.formValues.Id)}
                  >
                    {t("notifications.deletenot")}
                  </Button>
                </ToolbarItem>

                <ToolbarSeparator />
                <ToolbarItem>
                  <Button
                    disabled={pageState.processing}
                    className="snapshot"
                    style={{}}
                    title={t("notifications.snapshot")}
                    icon={"photo-camera"}
                    onClick={handleOnSnapshot}
                  ></Button>
                </ToolbarItem>
                <ToolbarSeparator />
              </Fragment>
            )}
            <ToolbarItem>
              <Button
                disabled={pageState.processing}
                style={{ color: currentTheme.primary }}
                icon={"close"}
                onClick={props.onClose}
              >
                {t("notifications.close")}
              </Button>
            </ToolbarItem>
          </Toolbar>
        </div>
        <div
          className="content"
          style={{ height: "100%" }}
          ref={contentZoneRef}
        >
          {(isTopVisible || !item || item.tabIndex == 0) && (
            <div className="top">
              <div className="row">
                <div className="column-left">
                  <div className="column-left-label">{t("notifications.title")}</div>
                  :&nbsp;
                  <div className="column-left-value">
                    {item.Title}
                    {/* {item.Title.substr(0, 50)} */}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="column-left">
                  <div className="column-left-label">{t("notifications.description")}</div>
                  :&nbsp;
                  <div className="column-left-value">{item.Description}</div>
                </div>
              </div>

              <div className="row">
                <div className="column-left">
                  <div className="column-left-label">
                    <span>{t("notifications.id")}</span>
                    {item.IsSystem && (
                      <span
                        className="k-icon k-i-gear"
                        style={{ marginLeft: 16 }}
                      ></span>
                    )}
                  </div>
                  :&nbsp;
                  <div className="column-right-value">{item.Id}</div>
                </div>
                {item.DatasetTitle && (
                  <div className="column-right">
                    <div className="column-right-label">{t("notifications.dataset")}</div>
                    :&nbsp;
                    <div className="column-right-value">
                      {item.DatasetTitle}
                    </div>
                  </div>
                )}
              </div>

              <div className="row">
                <div className="column-left">
                  <div className="column-left-label">{t("notifications.createdon")}</div>
                  :&nbsp;
                  <div className="column-left-value">
                    {formatDateTime(item.CreatedOn, false)} {t("notifications.utc")}
                  </div>
                </div>
                <div className="column-right">
                  <div className="column-left-label">{t("notifications.initiatedon")}</div>
                  :&nbsp;
                  <div className="column-left-value">
                    {formatDateTime(item.InitiatedOn, false)}
                  </div>
                </div>
              </div>

              {item.Type == 1 && (
                <div>
                  <div className="row">
                    <div className="column-left">
                      <div className="column-left-label">{t("notifications.grouped")}</div>
                      :&nbsp;
                      <div className="column-right-value">
                        {item.IsGrouped ? t("notifications.yes") : t("notifications.no")}
                      </div>
                    </div>
                    <div className="column-right">
                      <div className="column-right-label">
                        {item.IsVariant ? t("notifications.variation")  : t("notifications.isvariant")}
                      </div>
                      :&nbsp;
                      <div className="column-right-value">
                        {variantCoveredPeriodText}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="column-left">
                      <div className="column-left-label">{t("notifications.reccurs")}</div>
                      :&nbsp;
                      <div className="column-left-value">
                        {recurrsEveryText}
                      </div>
                    </div>
                    <div className="column-right">
                      <div className="column-right-label">{t("notifications.covered")}</div>
                      :&nbsp;
                      <div className="column-right-value">
                        {coveredPeriodText}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="column-left">
                      <div className="column-left-label">{t("notifications.starting")}</div>
                      :&nbsp;
                      <div className="column-left-value">
                        {formatDateTime(item.SDate, false)}
                      </div>
                    </div>
                    <div className="column-right">
                      <div className="column-right-label">{t("notifications.ending")}</div>
                      :&nbsp;
                      <div className="column-right-value">
                        {formatDateTime(item.EDate, false)}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="row">
                <div className="column-left">
                  <div className="column-left-label">{t("notifications.importance")}</div>
                  :&nbsp;
                  <div className="column-left-value">{importanceText}</div>
                </div>
                {item.Interpretation && (
                  <div className="column-right">
                    <div className="column-right-label">{t("notifications.interpretation")}</div>
                    :&nbsp;
                    <div className="column-right-value">
                      {parse(item.Interpretation)}
                    </div>
                  </div>
                )}
                {/* <div style={{display: "flex", flex: 1}}>
                                    <div className="column-left-label">
                                        Interpretation
                                    </div>
                                    :&nbsp;
                                    <div style={{flex: 1, marginLeft: 6}}>
                                        {parse(item.Interpretation)}                                    
                                    </div>
                                </div> */}
              </div>

              <div className="row">
                <div className="column-left">
                  <div className="column-left-label">{t("notifications.notify")}</div>
                  :&nbsp;
                  <div className="column-left-value">{notifyThroughText}</div>
                </div>
                <div className="column-right"></div>
              </div>

              <div
                className="row"
                style={{
                  borderTop: `1px solid ${currentTheme.componentBorderColor}`,
                  marginTop: 22,
                  marginBottom: 10,
                }}
              ></div>
            </div>
          )}

          {/* if type of notification is alert this section will appear */}

          {item.Type == 1 && (
            <div className="bottom" style={{ marginTop: 12, flex: 1 }}>
              {!item.IsGrouped && (
                <TabStrip
                  selected={item.tabIndex}
                  onSelect={(e) =>
                    dispatch(
                      setFormValue({ id: "tabIndex", value: e.selected })
                    )
                  }
                >
                  <TabStripTab title={t("notifications.analytics")}>
                    <Fragment>
                      <div
                        className="row"
                        style={{
                          marginBottom: 0,
                          marginTop: 2,
                          fontWeight: 700,
                        }}
                      >
                        <div style={{ flex: 1 }}>{t("notifications.data")}</div>
                        <div style={{ flex: 1 }}>
                          {t("notifications.history")}
                        </div>
                      </div>
                      <AlertNotificationNotGrouped
                        currentTheme={currentTheme}
                        resolvedExpression={item.ResolvedExpression}
                        value={item.AchievedValue}
                        operatorTitle={item.OperatorTitle}
                        thresholdMin={item.ThresholdMin.toString()}
                        thresholdMax={item.ThresholdMax.toString()}
                        variation={item.Difference}
                        isVariant={item.IsVariant}
                        history={item.History}
                      />
                    </Fragment>
                  </TabStripTab>
                  <TabStripTab title={t("notifications.raw")} className="raw-data-tab">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        padding: "4px, 8px",
                      }}
                    >
                      <Button
                        disabled={
                          !formValues.rawDataGridDataPaged ||
                          formValues.rawDataGridDataPaged.length < 1
                        }
                        style={{ marginRight: 16 }}
                        themeColor={"primary"}
                        onClick={handleRawDataGridExportToExcel}
                      >
                        {t("notifications.export")}
                      </Button>
                      <Button
                        style={{ marginRight: 16 }}
                        themeColor={"primary"}
                        onClick={handleToggleTop}
                      >
                        {t("notifications.toggle")}
                      </Button>
                      <Button
                        themeColor={"primary"}
                        onClick={handleShowGenerate}
                      >
                        {t("notifications.generate")}
                      </Button>
                    </div>
                    <div
                      className="raw-data-grid-container"
                      style={{ marginTop: 10 }}
                      ref={rawDataGridNotGroupedRef}
                    >
                      <ExcelExport
                        data={formValues.rawDataGridDataPaged}
                        ref={rawDataGridExportToExcelNotGroupedRef}
                      >
                        <Grid
                          style={{ height: "100%", width: "100%" }}
                          data={formValues.rawDataGridDataPaged}
                          resizable={true}
                          reorderable={true}
                          sortable={{
                            allowUnsort: true,
                            mode: "multiple",
                          }}
                          sort={formValues.rawDataGridSort}
                          onSortChange={handleRawDataGridSortChange}
                          pageable={{
                            buttonCount: 4,
                            //pageSizes: [5, 10, 15, "All"],
                            pageSizeValue: RAW_DATA_PAGE_SIZE,
                          }}
                          skip={formValues.rawDataGridPageSkip}
                          take={RAW_DATA_PAGE_SIZE}
                          pageSize={RAW_DATA_PAGE_SIZE}
                          total={formValues.rawDataGridData.length}
                          onPageChange={handleRawDataGridPageChange}
                          filterable={true}
                          filter={formValues.rawDataGridFilter}
                          onFilterChange={handleRawDataGridFilter}
                        >
                          {formValues.rawDataHeaders.map((item) => {
                            let filterType = "text";
                            let dataField = formValues.rawDataFields.find(
                              (e) => e.Title == item
                            );
                            if (dataField) {
                              if (dataField.DataTypeId == 1)
                                filterType = "boolean";
                              else if (dataField.DataTypeId == 2)
                                filterType = "numeric";
                              else if (dataField.DataTypeId == 3)
                                filterType = "text";
                              else if (
                                dataField.DataTypeId == 4 ||
                                dataField.DataTypeId == 5
                              )
                                filterType = "date";
                            }

                            let columnsCount = formValues.rawDataHeaders.length;
                            let columnWidth = 160;

                            // if (columnsCount < 7)
                            // {
                            //     let gridWidth = rawDataGridNotGroupedRef.current.clientWidth;

                            //     if (gridWidth)
                            //         columnWidth = Math.floor((gridWidth-2) / columnsCount);
                            // }

                            return (
                              <GridColumn
                                key={item}
                                field={item}
                                title={item}
                                width={columnWidth}
                                filter={filterType}
                              />
                            );
                          })}
                        </Grid>
                      </ExcelExport>
                    </div>
                  </TabStripTab>
                </TabStrip>
              )}
              {item.IsGrouped && (
                <TabStrip
                  selected={item.tabIndex}
                  onSelect={(e) =>
                    dispatch(
                      setFormValue({ id: "tabIndex", value: e.selected })
                    )
                  }
                >
                  <TabStripTab title={t("notifications.analytics")}>
                    <Fragment>
                      <AlertNotificationGrouped
                        currentTheme={currentTheme}
                        headers={item.GroupedData.Headers}
                        values={item.GroupedData.Values}
                        operatorTitle={item.OperatorTitle}
                        isPercent={item.isPercent}
                        isVariant={item.isVariant}
                      />
                    </Fragment>
                  </TabStripTab>
                  <TabStripTab title={t("notifications.raw")} className="raw-data-tab">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        padding: "4px, 8px",
                      }}
                    >
                      <Button
                        disabled={
                          !formValues.rawDataGridDataPaged ||
                          formValues.rawDataGridDataPaged.length < 1
                        }
                        style={{ marginRight: 16 }}
                        themeColor={"primary"}
                        onClick={handleRawDataGridExportToExcel}
                      >
                        {t("notifications.export")}
                      </Button>
                      <Button
                        style={{ marginRight: 16 }}
                        themeColor={"primary"}
                        onClick={handleToggleTop}
                      >
                        {t("notifications.toggle")}
                      </Button>
                      <Button
                        themeColor={"primary"}
                        onClick={handleShowGenerate}
                      >
                        {t("notifications.generate")}
                      </Button>
                    </div>
                    <div
                      className="raw-data-grid-container"
                      style={{ marginTop: 10 }}
                      ref={rawDataGridGroupedRef}
                    >
                      <ExcelExport
                        data={formValues.rawDataGridDataPaged}
                        ref={rawDataGridExportToExcelGroupedRef}
                      >
                        <Grid
                          style={{ height: "100%", width: "100%" }}
                          data={formValues.rawDataGridDataPaged}
                          resizable={true}
                          reorderable={true}
                          sortable={{
                            allowUnsort: true,
                            mode: "multiple",
                          }}
                          sort={formValues.rawDataGridSort}
                          onSortChange={handleRawDataGridSortChange}
                          pageable={{
                            buttonCount: 4,
                            //pageSizes: [5, 10, 15, "All"],
                            pageSizeValue: RAW_DATA_PAGE_SIZE,
                          }}
                          skip={formValues.rawDataGridPageSkip}
                          take={RAW_DATA_PAGE_SIZE}
                          pageSize={RAW_DATA_PAGE_SIZE}
                          total={formValues.rawDataGridData.length}
                          onPageChange={handleRawDataGridPageChange}
                          filterable={true}
                          filter={formValues.rawDataGridFilter}
                          onFilterChange={handleRawDataGridFilter}
                        >
                          {formValues.rawDataHeaders.map((item) => {
                            let filterType = "text";
                            let dataField = formValues.rawDataFields.find(
                              (e) => e.Title == item
                            );
                            if (dataField) {
                              if (dataField.DataTypeId == 1)
                                filterType = "boolean";
                              else if (dataField.DataTypeId == 2)
                                filterType = "numeric";
                              else if (dataField.DataTypeId == 3)
                                filterType = "text";
                              else if (
                                dataField.DataTypeId == 4 ||
                                dataField.DataTypeId == 5
                              )
                                filterType = "date";
                            }

                            let columnsCount = formValues.rawDataHeaders.length;
                            let columnWidth = 160;

                            // if (columnsCount < 7)
                            // {
                            //     console.log(">>", rawDataGridGroupedRef)
                            //     let gridWidth = rawDataGridGroupedRef.current.clientWidth;

                            //     if (gridWidth)
                            //        columnWidth = Math.floor((gridWidth-2) / columnsCount);
                            // }

                            return (
                              <GridColumn
                                key={item}
                                field={item}
                                title={item}
                                width={columnWidth}
                                filter={filterType}
                              />
                            );
                          })}
                        </Grid>
                      </ExcelExport>
                    </div>
                  </TabStripTab>
                </TabStrip>
              )}
            </div>
          )}
        </div>
        <Fragment>
          {pageState.formValues?.rawDataDialogOpen && (
            <Dialog className="alert-notification-rawdata-dialog" title={null}>
              <div className="toolbar">
                <Toolbar>
                  <ToolbarItem>
                    <Button
                      style={{ color: currentTheme.primary }}
                      icon="grid"
                      onClick={() => handleLoadRawData()}
                    >
                      {t("notifications.generate")}
                    </Button>
                  </ToolbarItem>
                  <ToolbarSeparator />
                  <ToolbarItem>
                    <Input
                      placeholder={t("notifications.locate")}
                      style={{ width: 320 }}
                      onChange={(e) => {
                        let title = e.value.trim().toLowerCase();
                        let fieldGroups =
                          pageState.formValues.rawDataFieldGroups;
                        let fields = pageState.formValues.rawDataFields;

                        // if (title && fieldGroups.find(e => e.trim().toLowerCase() == title))
                        //     dispatch(setFormValue({id: "rawDataFields", value: fields.map(item => {
                        //         if (item.FieldGroupTitle.trim().toLowerCase().indexOf(title) == 0)
                        //             return ({...item, IsVisible: true});
                        //         else
                        //             return ({...item, IsVisible: false});
                        //     })}));
                        // else
                        dispatch(
                          setFormValue({
                            id: "rawDataFields",
                            value: fields.map((item) => {
                              if (item.Title.toLowerCase().indexOf(title) >= 0)
                                return { ...item, IsVisible: true };
                              else return { ...item, IsVisible: false };
                            }),
                          })
                        );
                      }}
                    />
                  </ToolbarItem>
                  <ToolbarSeparator />
                  <ToolbarItem>
                    <Button
                      style={{ color: currentTheme.primary }}
                      icon="cancel"
                      onClick={() =>
                        dispatch(
                          setFormValue({
                            id: "rawDataDialogOpen",
                            value: false,
                          })
                        )
                      }
                    >
                      {t("notifications.cancel")}
                    </Button>
                  </ToolbarItem>
                  <ToolbarSeparator />
                </Toolbar>
              </div>
              <div className="content">
                {formValues.IsGrouped && (
                  <div className="row" style={{ marginTop: 16 }}>
                    <div>{t("notifications.grouping")}</div>
                    <DropDownListById
                      style={{ marginTop: 4 }}
                      value={formValues.rawDataAlertLogId}
                      data={formValues.rawDataGroupings}
                      dataItemKey={"Id"}
                      textField={"Title"}
                      onChange={(e) =>
                        dispatch(
                          setFormValue({
                            id: "rawDataAlertLogId",
                            value: e.value,
                          })
                        )
                      }
                    />
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    marginTop: 16,
                  }}
                >
                  <div className="row" style={{ flex: 1 }}>
                    <div>{t("notifications.select")}</div>
                    <DropDownListById
                      style={{ marginTop: 4, width: 180 }}
                      value={formValues.rawDataDirection}
                      data={[
                        { Id: 1, Title: "Asc" },
                        { Id: -1, Title: "Desc" },
                      ]}
                      dataItemKey={"Id"}
                      textField={"Title"}
                      onChange={(e) =>
                        dispatch(
                          setFormValue({
                            id: "rawDataDirection",
                            value: e.value,
                          })
                        )
                      }
                    />
                  </div>
                  <div className="row" style={{ flex: 1 }}>
                    <div>{t("notifications.rows")}</div>
                    <Input
                      type="number"
                      style={{ marginTop: 4, width: 120 }}
                      value={formValues.rawDataRowsCount}
                      onChange={(e) =>
                        dispatch(
                          setFormValue({
                            id: "rawDataRowsCount",
                            value: e.value,
                          })
                        )
                      }
                    />
                  </div>
                </div>
                <div className="row" style={{ marginTop: 16 }}>
                  <div style={{ marginBottom: 4 }}>{t("notifications.fields")}</div>
                  <List
                    className="list"
                    items={formValues.rawDataFields.filter((e) => e.IsVisible)}
                    itemRenderer={rawDataListItemRenderer(currentTheme)}
                    onFieldCheck={(item) => {
                      dispatch(toggleRawDataField(item.Id));
                    }}
                  />
                </div>
              </div>
            </Dialog>
          )}
        </Fragment>
      </div>
      <style>
        {`
                        .notifications-page .alert-notification
                        {
                            display: flex;
                            flex-direction: column;
                            height: 100%;
                            background-color: transparent;
                            padding-left: 0px;
                            border: ${currentTheme.pageFormBorder};   
                            border-radius: ${currentTheme.pageBorderRadius};
                            overflow: hidden;
                            border-left: none;
                        }


                        /*toolbar*/
                        .notifications-page .alert-notification > .toolbar
                        {
                            flex-grow: 0;
                            flex-shrink: 0;                                
                        }
                        
                        .notifications-page .alert-notification > .toolbar .k-toolbar
                        {
                            /*margin-left:-6px;*/
                            padding : 3px 4px 2px 0px;                            
                            background-color: transparent;
                            border-top: none;
                            border-color: ${currentTheme.separatorColor};
                        }

                        .notifications-page .alert-notification > .toolbar .k-toolbar .k-separator 
                        {
                            border-color: ${currentTheme.primary};
                        }

                        .notifications-page .alert-notification > .toolbar .k-toolbar .k-button
                        {
                            background-color: transparent;      
                            border: none;
                            padding: 6px 8px;                      
                        }

                        .notifications-page .alert-notification > .toolbar .k-toolbar .k-split-button:focus, .notifications-page .alert-notification .toolbar .k-toolbar .k-split-button.k-focus,
                        .notifications-page .alert-notification > .toolbar .k-toolbar .k-button-solid-base:focus, .notifications-page .alert-notification .toolbar .k-toolbar .k-button-solid-base.k-focus
                        {
                            box-shadow: none !important;
                            border: none !important;
                        }

                        .notifications-page .alert-notification > .toolbar .k-toolbar .k-button:active::before, .notifications-page .alert-notification > .toolbar .k-toolbar .k-button:hover::before,
                        .notifications-page .alert-notification > .toolbar .k-toolbar .k-button:focus::before, .notifications-page .alert-notification > .toolbar .k-toolbar .k-button:focus-within::before                        
                        {
                            opacity: 0 !important;
                            border: none !important;
                            box-shadow: none !important;
                        }

                        .form-toolbar > .k-toolbar .k-dropdown-button.k-focus .k-button::after
                        {
                            /*border: 1px solid ${currentTheme.componentBg} !important;*/
                            box-shadow: none !important;
                        }                       

                        /*.notifications-page .alert-notification > .toolbar .k-toolbar .k-button .k-button-text
                        {
                            font-size: 13px;
                            font-weight: 400;
                            color: ${currentTheme.componentText};
                        }
                        
                        .notifications-page .alert-notification > .toolbar .k-toolbar .k-button:hover .k-button-text
                        {
                            font-weight: 700;
                            font-size: 12.2px;
                            color: ${currentTheme.componentText};
                        }*/

                        .notifications-page .alert-notification > .toolbar .k-button-icon
                        {
                          font-weight: 500;
                          color: ${currentTheme.primary};
                        }
                        /*toolbar*/
    
                       
                        .notifications-page .alert-notification .content
                        {
                            display: flex;
                            flex-direction: column;
                            flex:1;
                            // border-left: 1px solid ${currentTheme.componentBorderColor};
                            padding: 0px 24px 8px 24px;
                            /*width: 900px;*/
                            overflow-y: auto;
                        }

                        .notifications-page .alert-notification .top,
                        {
                            display: flex;
                            flex-direction: column;
                            align-items: stretch;
                        }
                        
                        .notifications-page .alert-notification .bottom
                        {
                            display: flex;
                            flex-direction: column;
                            align-items: stretch;
                            overflow-y: hidden;
                            min-height: 200px;
                        }
                        
                        .notifications-page .alert-notification .row,
                        .notifications-page .alert-notification .row
                        {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            margin-top: 14px;
                        }

                        .notifications-page .alert-notification .row .column-left,
                        .notifications-page .alert-notification .row .column-right
                        {
                            display: flex;
                            align-items: center;
                            flex: 1;
                        }

                        .notifications-page .alert-notification .row .column-left-label,
                        .notifications-page .alert-notification .row .column-right-label
                        {
                            font-weight: 700;
                            font-size: 13px;
                            width: 115px;
                        }

                        .notifications-page .alert-notification .row .column-left-value,
                        .notifications-page .alert-notification .row .column-right-value
                        {
                            flex: 1;
                            margin-left: 6px;
                            font-size: 13px;
                        }

                        .notifications-page .alert-notification .bottom .k-tabstrip
                        {
                            height: 100%;
                        }

                        .notifications-page .alert-notification .k-tabstrip .k-content .k-animation-container
                        {
                            width: 100%;
                            height: calc(100% - 8px);
                        }



                        .notifications-page .alert-notification .k-tabstrip .k-content .k-animation-container .k-child-animation-container
                        {
                            height: 100%;
                        }
                        .notifications-page .alert-notification .k-tabstrip .k-content .k-animation-container .k-child-animation-container > div
                        {
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                        }

                        .notifications-page .alert-notification .k-tabstrip .k-content .k-animation-container .k-child-animation-container > div > .raw-data-grid-container
                        {
                            flex: 1;
                            overflow-y: hidden;
                        }

                      

                        .notifications-page .alert-notification .k-tabstrip .k-content
                        {
                            padding-top: 8px;
                        }

                        .notifications-page .k-tabstrip-items .k-link {
                            color:${currentTheme.primary};
                          }

                        /*raw data dialog*/
                        .alert-notification-rawdata-dialog .k-dialog-content
                        {
                            display: flex;
                            flex-direction: column;
                            align-items: stretch;
                            padding: 0!important;
                            width: 600px;
                            overflow: hidden;
                        }

                        .alert-notification-rawdata-dialog .toolbar .k-toolbar input
                        {
                            background-color: transparent;
                            color: ${currentTheme.dialogToolbarText};
                            border: none;
                        }

                        .alert-notification-rawdata-dialog .toolbar .k-toolbar input::placeholder
                        {
                            color: ${currentTheme.dialogToolbarText};
                        }

                        .alert-notification-rawdata-dialog .toolbar .k-toolbar
                        {
                            width: 100%;
                        }

                        .alert-notification-rawdata-dialog .toolbar .k-toolbar
                        {
                            width: 100%;
                            border-left: none !important;
                            border-bottom: 1px solid ${currentTheme.separatorColor};
                            border-top: none !important;
                            border-right: none !important;
                            padding: 3px 4px 2px 0px;
                            background-color: ${currentTheme.appBarBg}; /*transparent;*/
                        }

                        .alert-notification-rawdata-dialog .toolbar .k-button
                        {
                            /*the toolbar buttons*/
                            border: none;
                            padding: 6px 8px;
                            background-color:transparent;
                        }

                        .alert-notification-rawdata-dialog .toolbar .k-separator 
                        {
                            border-color: ${currentTheme.appBarLinkColor};/* ${currentTheme.primary}*/
                        }

                        .alert-notification-rawdata-dialog .toolbar .k-toolbar .k-split-button:focus, .form-root .toolbar .k-toolbar .k-split-button.k-focus,
                        .alert-notification-rawdata-dialog .toolbar .k-toolbar .k-button-solid-base:focus, .form-root .toolbar .k-toolbar .k-button-solid-base.k-focus
                        {
                            box-shadow: none !important;
                            border: none !important;
                        }

                        .alert-notification-rawdata-dialog .toolbar .k-toolbar .k-button:active::before, .alert-notification-rawdata-dialog .toolbar .k-toolbar .k-button:hover::before,
                        .alert-notification-rawdata-dialog .toolbar .k-toolbar .k-button:focus::before, .alert-notification-rawdata-dialog .toolbar .k-toolbar .k-button:focus-within::before                        
                        {
                            opacity: 0 !important;
                            border: none !important;
                            box-shadow: none !important;
                        }

                        .alert-notification-rawdata-dialog .toolbar .k-toolbar .k-dropdown-button.k-focus .k-button::after
                        {
                            /*border: 1px solid ${currentTheme.componentBg} !important;*/
                            box-shadow: none !important;
                        }                       

                        .alert-notification-rawdata-dialog .toolbar .k-toolbar .k-button .k-button-text
                        {
                            font-size: 13px;
                            font-weight: 400;
                            color: ${currentTheme.appBarLinkColor};
                        }

                        .alert-notification-rawdata-dialog .toolbar .k-button-icon
                        {
                            font-weight: 500;
                            color: ${currentTheme.appBarLinkColor};/*${currentTheme.primary};*/
                        }

                        .alert-notification-rawdata-dialog .toolbar .k-toolbar .k-button:hover .k-button-text
                        {
                            font-weight: 700;
                            font-size: 12.2px;
                        }
                        /*form toolbar*/

                        .alert-notification-rawdata-dialog .k-dialog-content .content
                        {
                            padding: 2px 18px 18px 18px;
                            flex: 1;
                            overflow-y: auto;
                        }

                        .alert-notification-rawdata-dialog .k-dialog-content .content .row
                        {
                            display: flex;
                            flex-direction: column;
                            justify-content: flex-start;
                            align-items: stretch;
                        }

                        .alert-notification-rawdata-dialog .k-dialog-content .content .k-dropdownlist
                        {
                            background-color: transparent;
                        }

                        .alert-notification-rawdata-dialog .k-dialog-content .content .list-container
                        {
                            border: 1px solid ${currentTheme.separatorColor};
                            border-radius: 6px;
                            height: 400px;
                        }

                        /*rawdata grid*/
                        .notifications-page .raw-data-grid-container .k-grid 
                        {
                            border: ${currentTheme.gridBorder};
                        }
    
                        .notifications-page .raw-data-grid-container .k-grid .k-grid-content
                        {
                            overflow-y: auto;
                        }
    
                        .notifications-page .raw-data-grid-container .k-grid table thead tr
                        {
                            background-color: ${currentTheme.gridHeaderBg};
                            color: ${currentTheme.gridHeaderColor};
                        }

                        .notifications-page .raw-data-grid-container .k-grid .k-master-row > td
                        {
                            border-bottom: 1px solid ${currentTheme.componentBorderColor};
                        }
    
                        .notifications-page .raw-data-grid-container .k-grid .k-master-row:last-child > td
                        {
                            border-bottom: none;
                        }

                        .notifications-page .raw-data-grid-container .k-grid .k-master-row.k-alt,
                        .notifications-page .raw-data-grid-container .k-grid .k-master-row.k-alt:hover,
                        .notifications-page .raw-data-grid-container .k-grid .k-master-row:hover
                        {
                            background-color: ${currentTheme.componentBg};
                        }   
                        
                        .notifications-page .raw-data-grid-container .k-pager
                        {
                            display: flex;
                            border-top: 1px solid ${currentTheme.componentBorderColor};
                        }

                        .notifications-page .raw-data-grid-container .k-grid th, .k-grid td 
                        {
                            padding: 4px 12px;
                        }

                        .notifications-page .k-grid .k-pager-numbers .k-link.k-state-selected, .k-pager-numbers .k-link.k-selected {
                            color: ${currentTheme.gridPageSelectedNumberColor};
                        }
                    `}
      </style>
    </Fragment>
  );
};
